import {
    Box,
    Heading,
    Text,
} from 'grommet';

import ResponsiveGrid from "../ResponsiveGrid";

import GraphTableRow from './GraphTableRow'


const url = window.location.href.split('/');
let state = url[url.length-1].split('=')[1].toUpperCase();
let STATE = '';
switch(state.toLowerCase()) {
    case "va": STATE = "Virginia"; break;
    case "nc": STATE = "North Carolina"; break;
    case "ky": STATE = "Kentucky"; break;
    case "ga": STATE = "Georgia"; break;
    case "tn": STATE = "Tennessee"; break;
    case "al": STATE = "Alabama"; break
    case "ms": STATE = "Mississippi"; break
}



const style = {
    table: {
        borderStyle: "solid",
        borderWidth: "1.5px",
        borderColor: '#B1B1B1',
        width: "100%"
    },
    tableHeader: {
        backgroundColor: '#FFFFFF',
        borderStyle: 'solid',
        borderColor: '#B1B1B1',
        borderWidth: '1.5px',
        borderBottomWidth: '0px',
        color: '#232C3B'
    }
}

const columns = {
    small: ["100%"],
    medium: ["45%", "auto"],
    large: ["45%", "auto"],
};

const rows = {
    small: ["auto"],
    medium: ["auto"],
    large: ["auto"],
    xlarge: ["xxsmall"]
};



function GraphTable({title, data, score, total}) {
    return (
        <>
            <Heading className="tableHeading" level="2" alignSelf="start" color="appGreen" style={{paddingLeft: "10px", marginBottom: "15px"}}>
                {title}
            </Heading>
            <ResponsiveGrid
                width="100%"
                height="45px"
                overrideColumns={columns}
                overrideRows={rows}
            >
                <Box
                    flex={false}
                    justify="center"
                    pad="small"
                    style={style.tableHeader}
                >
                    <Heading level="3">{STATE} Electric Co-ops</Heading>
                </Box>
                <Box
                    flex={false}
                    justify="center"
                    pad="small"
                    style={style.tableHeader}
                >
                    <Heading level="3">Score<Text> (out of {total})</Text></Heading>
                </Box>
            </ResponsiveGrid>
            <div style={style.table}>
                {data.map((datum, i) => (
                    <GraphTableRow
                        name={datum.Utility_Name}
                        max={total}
                        score={datum[score]}
                        key={i}
                        data={datum}
                        cid={datum.Utility_Number}/>
                ))}
            </div>
        </>
    );
}

export default GraphTable;